import React from 'react';
import { Row, Col, Input, Select, Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
const ManagePagesListItem = ({
  page,
  enabledSkills,
  handleDelete,
  handleNameChange,
  handleProductChange,
  index,
  disableDelete,
  error,
}) => {
  const { Option } = Select;
  return (
    <div style={{ paddingTop: '16px' }}>
      <Row>
        <Col style={{ paddingRight: '16px' }} span={8}>
          {error ? (
            error.name ? (
              <div style={{ color: 'red' }}>{error.name}</div>
            ) : (
              <div>&nbsp;</div>
            )
          ) : (
            ''
          )}
          <Input
            onChange={(value) => handleNameChange(value, page._id)}
            placeholder='Type name'
            value={page.name}
          />
        </Col>
        <Col style={{ paddingRight: '16px' }} span={8}>
          {error ? (
            error.pageViewType ? (
              <div style={{ color: 'red' }}>{error.pageViewType}</div>
            ) : (
              <div>&nbsp;</div>
            )
          ) : (
            ''
          )}
          <Select
            placeholder='Select Product'
            value={page.pageViewType}
            style={{ width: '100%' }}
            onChange={(value) => {
              handleProductChange(value, page._id);
            }}
          >
            {enabledSkills.map((item, index) => (
              <Option key={index} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={8}>
          {error ? <div>&nbsp;</div> : ''}

          <Button
            disabled={disableDelete}
            icon={<DeleteOutlined />}
            onClick={() => {
              handleDelete(page._id);
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ManagePagesListItem;
